import {Coupon} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/coupon.types';
import {
  CouponLandingPageConditionalLoginWrapper,
  CouponLandingPageHeaderDesktop,
  CouponLandingPageInlineFilter,
  CouponLandingPageMeta,
  CouponLandingPageProductStream,
  CouponLandingPageStreamHeader,
  CouponLangingPageNavigationTree,
  InteractiveProductTile,
  ProductMiniAdpWithBasketFlyout,
  SizeSelectionOpenedStateKey,
  useMiniAdpDialogOpenedState,
  useProductStreamDisplayState,
} from '@aboutyou/logic-components';
import {ScrollTopAnchor} from '@aboutyou/router';
import {SplitView, Z_INDEXES} from '@aboutyou/ui-components';
import React, {StrictMode, Suspense, useRef, useState} from 'react';
import {Sticky} from 'react-stickup-ay';
import styled from 'styled-components';
import {useADPPreload} from '../ArticleDetailPage/useADPPreload';

const loadMoreComponentDisplayConfig = {
  tilesBeforeFirstDisplay: 10000,
  tilesBeforeConsecutivelyDisplay: 10000,
};

const Page: React.FC = () => {
  const {productImageType, updateProductImageType} =
    useProductStreamDisplayState();
  const sidebarRef = useRef<HTMLDivElement>(null);
  const {open: openProductMiniADPDialog} = useMiniAdpDialogOpenedState();
  const inlineFiltersRef = useRef<HTMLDivElement>(null);
  const [coupon, setCoupon] = useState<Coupon>();

  useADPPreload();

  return (
    <StrictMode>
      <CouponLandingPageMeta />
      <StyledCouponLandingPageHeaderDesktop setCoupon={setCoupon} />
      <ScrollTopAnchor
        as={StyledSplitView}
        split={'30:70'}
        splitMedium={'20:80'}
        splitLarge={'15:85'}
        refStart={sidebarRef}
        contentStart={
          <Suspense>
            <Sticky
              overflowScroll="flow"
              experimentalNative
              container={sidebarRef}
              style={{zIndex: Z_INDEXES.CATEGORY_TREE}}
              defaultOffsetTop={196}
            >
              <StyledCouponLangingPageNavigationTree />
            </Sticky>
          </Suspense>
        }
        contentEnd={
          <section>
            <CouponLandingPageStreamHeader
              productImageType={productImageType}
              onChangeProductImageType={updateProductImageType}
              inlineFiltersRef={inlineFiltersRef}
              offsetTop={64}
            />
            <FiltersAndProductStreamWrapper>
              <CouponLandingPageInlineFilter
                inlineFiltersRef={inlineFiltersRef}
              />
              <CouponLandingPageProductStream
                gridColumns={undefined}
                preferredProductImageType={productImageType}
                loadMoreComponentDisplayConfig={loadMoreComponentDisplayConfig}
                onClickAddCta={openProductMiniADPDialog}
                coupon={coupon}
                interactiveHoverMode={true}
                ProductTileComponent={InteractiveProductTile}
              />
            </FiltersAndProductStreamWrapper>
          </section>
        }
      />

      <ProductMiniAdpWithBasketFlyout
        showAddToWishlistButton
        sizeSelectionStateManagerKey={
          SizeSelectionOpenedStateKey.MAIN_SIZE_SELECTION
        }
      />
    </StrictMode>
  );
};

export const CouponLandingPage = () => {
  return <CouponLandingPageConditionalLoginWrapper View={Page} />;
};

const StyledSplitView = styled(SplitView)`
  padding-top: 28px;
`;

const StyledCouponLandingPageHeaderDesktop = styled(
  CouponLandingPageHeaderDesktop,
)`
  margin-top: 30px;
`;

const StyledCouponLangingPageNavigationTree = styled(
  CouponLangingPageNavigationTree,
)`
  margin: 1.65rem 0;
  word-break: break-word;
  transform: translateY(-196px);
  transition: transform 0.3s;

  *:has([data-collapsed='true']) & {
    transform: translateY(-68px);
  }
`;

const FiltersAndProductStreamWrapper = styled.div`
  overflow: hidden;
`;
